// Interface User alignée EXACTEMENT sur EKOSE-API Backend Prisma Schema
export interface User {
  id: string | number;
  name: string;
  email: string;
  emailHash?: string;
  password?: string;
  role: UserRole; // ✅ Enum Prisma UserRole
  phoneNumber?: string; // ✅ camelCase Prisma
  residence?: string;
  countryCode?: string; // ✅ Phase 2
  dialCode?: string;    // ✅ Phase 2
  availabilityStatus: DoctorAvailabilityStatus; // ✅ Enum Prisma
  shortNumber?: string;
  totalConsultations: number;
  status: UserStatus; // ✅ Enum Prisma UserStatus
  isActive: boolean; // ✅ camelCase Prisma
  mfaEnabled: boolean;
  mfaSecret?: string;
  deletedAt?: string;
  mfaBackupCodes?: string;
  createdAt: string; // ✅ camelCase Prisma
  updatedAt: string; // ✅ camelCase Prisma
  preferences?: Record<string, unknown>;
  avatar?: string;

  // ✅ Profils séparés comme dans Prisma
  doctorProfile?: DoctorProfile;
  patientProfile?: PatientProfile;

  // Champs calculés/legacy (générés côté backend)
  phone?: string; // Alias vers phoneNumber
  speciality?: string; // Alias vers doctorProfile?.speciality
  licenseNumber?: string; // Alias vers doctorProfile?.licenseNumber
  dateOfBirth?: string; // Alias vers patientProfile?.dateOfBirth

  // Adhésions cliniques
  clinicMemberships?: Array<{
    clinicId: string;
    role: string;
    department?: string | null;
    clinicName: string;
    clinicSlug?: string | null;
    clinicType?: string | null;
    logoUrl?: string | null;
  }>;
  activeClinicId?: string | null;
  activeClinicRole?: string | null;
}

// ✅ Interface DoctorProfile alignée sur Prisma
export interface DoctorProfile {
  id: string | number;
  userId: string | number;
  speciality?: string;
  licenseNumber?: string;
  experienceYears?: number;
  education?: string;
  certifications?: string;
  consultationFee?: number;
  availabilityHours?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// ✅ Interface PatientProfile alignée sur Prisma
export interface PatientProfile {
  id: string | number;
  userId: string | number;
  dateOfBirth?: string;
  gender?: string;
  bloodType?: string;
  allergies?: string;
  medicalHistory?: string;
  emergencyContact?: string;
  residence?: string;
  insuranceNumber?: string;
  age?: string;
  lastVisit?: string;
  createdAt: string;
  updatedAt: string;
}

// ✅ Enums Prisma importés
export enum UserRole {
  ADMIN = 'ADMIN',
  DOCTOR = 'DOCTOR',
  PATIENT = 'PATIENT'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED'
}

export enum DoctorAvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE'
}

// Interface pour les réponses d'erreur
export interface ApiError {
  status: 'error';
  message: string;
}

// Interface pour les réponses de succès
export interface ApiResponse<T> {
  status: 'success';
  message?: string;
  data?: T;
}

// Interface pour l'authentification
export interface AuthResponse {
  token: string;
  user: User;
}

// Interface pour les requêtes d'authentification
export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string; // ✅ Backend utilise 'name'
  email: string;
  password: string;
  role: UserRole; // ✅ Enum au lieu de string
  phoneNumber?: string; // ✅ camelCase
  residence?: string;
  city?: string; // Ajouté pour EKOSE-API
  region?: string; // Ajouté pour EKOSE-API
  speciality?: string; // Pour médecins
  licenseNumber?: string; // ✅ camelCase
  dateOfBirth?: string; // ✅ camelCase
  gender?: string; // Pour patients
  bloodType?: string; // Pour patients
} 